// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".centered[data-v-9f3f934c]{width:100%;height:100%;display:flex;justify-content:center;align-items:center}", ""]);
// Exports
module.exports = exports;
